import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OktaService {
    username: BehaviorSubject<string> = new BehaviorSubject<string>('');
    accessToken: string = '';
    fullName: string = '';
    impersonateMode = false;
    admin: boolean = false;
    superAdmin: BehaviorSubject<boolean|null> = new BehaviorSubject<boolean|null>(null);

    get usernameUpdated(): Observable<string> {
        return this.username.asObservable();
    }

    get superAdminUpdated(): Observable<boolean|null> {
        return this.superAdmin.asObservable();
    }
}
